module.exports = __webpack_public_path__ + "img/1-活码设置-01.13ae8a24.png";